const $ = require('jquery')
// ドロップダウンメニュー
$(function () {
  $('.menu-box__list--box').hover(function () {
    $('.menu-box__list--box ul').addClass('dropdown')
  })
})
